import { UseQueryOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';
import { UserGroupMember } from 'types/user_group';

import { useAPI } from 'hooks/api/useAPI';
import { useAuthenticatedQuery } from 'hooks/api/useAuthenticatedQuery';

type UseUserGroupMembersOptions = UseQueryOptions<
  UserGroupMember[],
  APIError
> & {
  groupId: string;
};

export function useUserGroupMembers({
  groupId,
  queryKey = ['user-group-members'],
  ...options
}: UseUserGroupMembersOptions) {
  const { applicationID, client } = useAPI();

  return useAuthenticatedQuery(
    [...queryKey, applicationID, groupId],
    async () => {
      const { data } = await client.get<UserGroupMember[]>(
        `/apps/${applicationID}/user_groups/${groupId}/members`
      );
      return data;
    },
    {
      enabled: Boolean(groupId),
      ...options,
    }
  );
}
